// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"AY-z","sponsoredTooltipWrapper":"BY-z","sponsoredTooltip":"CY-z","newCard":"DY-z"};